
export class GetStaggingOrderPayload {

    public StaggingId?: any;
    public OrderNumber?: string;
    public StatusId?: number;
    public AgentId?: string;
    public TenantId?: string;
    public OrderStageDatetime?: Date;
    public InventoryLocations?: any;
}